const moment = require('moment');
import axios from 'axios';
import config from '../config/configuration.js';
import AuthenticationService from './AuthenticationService';

import * as pdfMake from 'pdfmake-support-chinese-fonts/pdfmake.min';
import * as pdfFonts from 'pdfmake-support-chinese-fonts/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
	Roboto: {
		normal: 'Roboto-Regular.ttf',
		bold: 'Roboto-Regular.ttf',
		italics: 'Roboto-Regular.ttf',
		bolditalics: 'Roboto-Regular.ttf'
	},
	fangzhen: {
		normal: 'fzhei-jt.TTF',
		bold: 'fzhei-jt.TTF',
		italics: 'fzhei-jt.TTF',
		bolditalics: 'fzhei-jt.TTF'
	}
};

const authenticationService = new AuthenticationService();

export default class ProposalService {

	// static applicationTypeOptions = ['常规测试', '首次申请', '免费机时（只在每一轮固定时间段申请）'];
	static applicationTypeOptions = ['常规测试', '首次申请'];
	static projectPropertyOptions = ['科研', '企业', '自由'];

	static proposalSteps = [
		{ step: 0, stepName: '申请人填写' },
		{ step: 1, stepName: '预审核' },
		{ step: 2, stepName: '审核' },
		{ step: 3, stepName: '实验总结' },
		{ step: 4, stepName: '结束' },
	];

	static proposalStepsToDisplay = [
		// lightgray 	#D3D3D3 	rgb(211, 211, 211)
		// deepskyblue 	#00BFFF 	rgb(0, 191, 255)
		// limegreen 	#32CD32 	rgb(50, 205, 50)
		{ step: 0, displayName: '待申请人填写', displayColor: 'rgba(211, 211, 211, 0.6)' },
		{ step: 1, displayName: '待预审核', displayColor: 'rgba(0, 191, 255, 0.2)' },
		{ step: 2, displayName: '待审核', displayColor: 'rgba(0, 191, 255, 0.5)' },
		{ step: 3, displayName: '待实验总结', displayColor: 'rgba(50, 205, 50, 0.4)' },
		{ step: 4, displayName: '已结束', displayColor: 'rgba(50, 205, 50, 1)' },
	];

	getApplicationTypeOptions() {
		return ProposalService.applicationTypeOptions;
	}

	getProjectPropertyOptions() {
		return ProposalService.projectPropertyOptions;
	}

	displayRoleNames(roles) {
		let roleNames = '';
		for(let i = 0; i < roles.length; i++) {
			for(let item of ProposalService.roleOptions) {
				if(roles[i] === item.value) {
					if(i !== 0) roleNames += ', ';
					roleNames += item.name;
					break;
				}
			}
		}
		return roleNames;
	}

	// findProposals(filters) {
	// 	let url = `${config.serverPath}/proposals`;
	// 	if(filters === undefined) return axios.get(url, {headers: authenticationService.authHeader()}).then(res => res.data);

	// 	if(!(Object.entries(filters).length === 0 && filters.constructor === Object)) {
	// 		for (const [key, value] of Object.entries(filters)) {
	// 			if(typeof value === 'boolean' || value) {
	// 				if(url.includes('?')) {
	// 					url += `&${key}=${value}`;
	// 				} else {
	// 					url += `?${key}=${value}`;
	// 				}
	// 			}
	// 		}
	// 	}
	// 	return axios.get(url, {headers: authenticationService.authHeader()}).then(res => res.data);
	// }

	exportProposals() {
        let url = `${config.serverPath}/proposals/export`;
		return axios.get(url, {headers: authenticationService.authHeader(), responseType: 'blob'});
	}

	findAllProposals(lazyParams) {
		let url = `${config.serverPath}/proposals/all`;
		return axios.get(url, {headers: authenticationService.authHeader(), params: {lazyEvent: JSON.stringify( lazyParams )}}).then(res => res.data);
	}

	findSelfProposals() {
		let url = `${config.serverPath}/proposals/self`;
		return axios.get(url, {headers: authenticationService.authHeader()}).then(res => res.data);
	}

	findSingleProposal(_id) {
        let url = `${config.serverPath}/proposals/single/${_id}`;
		return axios.get(url, {headers: authenticationService.authHeader()}).then(res => res.data);
	}

	saveProposal(proposal) {
		let url = `${config.serverPath}/proposals/save`;
		return axios.post(url, proposal, {headers: authenticationService.authHeader()}).then(res => res.data);
	}

	submitProposal(proposal) {
		let url = `${config.serverPath}/proposals/submit`;
		return axios.post(url, proposal, {headers: authenticationService.authHeader()}).then(res => res.data);
	}

	saveSummary(id, summary) {
		let url = `${config.serverPath}/proposals/summary/save/${id}`;
		return axios.post(url, {summary: summary}, {headers: authenticationService.authHeader()}).then(res => res.data);
	}

	submitSummary(id, summary) {
		let url = `${config.serverPath}/proposals/summary/submit/${id}`;
		return axios.post(url, {summary: summary}, {headers: authenticationService.authHeader()}).then(res => res.data);
	}

	calculateBeamTime(start, end) {
		let url = `${config.serverPath}/proposals/summary/beamtime?start=${start}&end=${end}`;
		return axios.get(url, {headers: authenticationService.authHeader()}).then(res => res.data);
	}

	attachmentUrl() {
        return `${config.serverPath}/proposals/attachments`;
	}

	getAttachment(id) {
        let url = `${config.serverPath}/proposals/attachments/${id}`;
		// return axios.get(url, {headers: authenticationService.authHeader(), responseType: 'blob'}).then(res => res.data);
		return axios.get(url, {headers: authenticationService.authHeader(), responseType: 'blob'});
	}

	// updateProposal(_id, proposal) {
	// 	let url = `${config.serverPath}/proposals/${_id}`;
	// 	return axios.put(url, proposal, {headers: authenticationService.authHeader()}).then(res => res.data);
	// }

	deleteProposal(_id) {
		let url = `${config.serverPath}/proposals/${_id}`;
		return axios.delete(url, {headers: authenticationService.authHeader()}).then(res => res.data);
	}

	// reportFileUrl(id) {
    //     return `${config.serverPath}/proposals/file/${id}`;
	// }

	// reportProposal(proposal) {
	// 	let url = `${config.serverPath}/proposals/report`;
	// 	return axios.post(url, proposal, { headers: authenticationService.authHeader() }).then(res => res.data);
	// }

	showProposalStatus(proposal) {
		let displayName = '';
		for(let item of ProposalService.proposalStepsToDisplay) {
			if(proposal.step === item.step) {
				displayName = item.displayName;
				break;
			}
		}
		return displayName;
	}

	showProposalStatusColor(proposal) {
		let displayColor = '';
		for(let item of ProposalService.proposalStepsToDisplay) {
			if(proposal.step === item.step) {
				displayColor = item.displayColor;
				break;
			}
		}
		return displayColor;
	}

	showProposalApprover(proposal) {
		let persons = new Set();

		for(let h of proposal.history) {
			if(h.step === 1 || h.step === 2) {
				persons.add(h.person);
			}
		}

		let str = Array.from(persons).join(' ');
		return str;
	}

	preapproverAccept(prpposal) {
		let url = `${config.serverPath}/proposals/preapproveraccept/${prpposal._id}`;
		return axios.put(url, {assignedDate: prpposal.assignedDate, assignedBeamTime: prpposal.assignedBeamTime}, { headers: authenticationService.authHeader() }).then(res => res.data);
	}

	preapproverReject(prpposal) {
		let url = `${config.serverPath}/proposals/preapproverreject/${prpposal._id}`;
		return axios.put(url, {comment: prpposal.comment}, { headers: authenticationService.authHeader() }).then(res => res.data);
	}

	approverAccept(prpposal) {
		let url = `${config.serverPath}/proposals/approveraccept/${prpposal._id}`;
		return axios.put(url, {assignedDate: prpposal.assignedDate, assignedBeamTime: prpposal.assignedBeamTime}, { headers: authenticationService.authHeader() }).then(res => res.data);
	}

	approverReject(prpposal) {
		let url = `${config.serverPath}/proposals/approverreject/${prpposal._id}`;
		return axios.put(url, {comment: prpposal.comment}, { headers: authenticationService.authHeader() }).then(res => res.data);
	}

	findAllToApprove() {
        let url = `${config.serverPath}/proposals/alltoapprove`;
		return axios.get(url, { headers: authenticationService.authHeader() }).then(res => res.data);
	}

	findPreapproverToApprove() {
        let url = `${config.serverPath}/proposals/preapprovertoapprove`;
		return axios.get(url, { headers: authenticationService.authHeader() }).then(res => res.data);
	}

	findApproverToApprove() {
        let url = `${config.serverPath}/proposals/approvertoapprove`;
		return axios.get(url, { headers: authenticationService.authHeader() }).then(res => res.data);
	}

	findApproved(lazyParams) {
        let url = `${config.serverPath}/proposals/approved`;
		return axios.get(url, { headers: authenticationService.authHeader(), params: {lazyEvent: JSON.stringify( lazyParams )}}).then(res => res.data);
	}

	calculateCountToApprove() {
		let url = `${config.serverPath}/proposals/counttoapprove`;
		return axios.get(url, { headers: authenticationService.authHeader() }).then(res => res.data);
	}

	buildProposalTimeline(proposal) {
		let promises = [null, null, null];
		let promise0;
		let promise1;

		let url0 = `${config.serverPath}/proposals/preapprover`;
		promise0 = axios.get(url0, {headers: authenticationService.authHeader()}).then(res => res.data);
		promises[0] = promise0;

		let url1 = `${config.serverPath}/proposals/approver`;
		promise1 = axios.get(url1, {headers: authenticationService.authHeader()}).then(res => res.data);
		promises[1] = promise1;

        return Promise.all(promises).then((values) => {
			// console.log(values);

			let timeline = [];
			timeline.push(
				{ 
					step: 0,
					person: proposal.createdBy ? proposal.createdBy.name : ''
				});
			
			if(values[0] && values[0].length) {
				let preapprovers = values[0];
				let str = '';
				for(let i = 0; i < preapprovers.length; i++) {
					if(i > 0) str += ' ';
					str += preapprovers[i].name;
				}
				timeline.push(
					{ 
						step: 1,
						person: str
					});
			}

			if(values[1] && values[1].length) {
				let approvers = values[1];
				let str = '';
				for(let i = 0; i < approvers.length; i++) {
					if(i > 0) str += ' ';
					str += approvers[i].name;
				}
				timeline.push(
					{ 
						step: 2,
						person: str
					});
			}

			timeline.push(
				{ 
					step: 3,
					person: proposal.createdBy ? proposal.createdBy.name : ''
				});

			timeline.push(
				{ 
					step: 4
				});

			let index;
			for(let i = 0; i < timeline.length; i++) {
				if(timeline[i].step === proposal.step) {
					index = i;
					timeline[i].current = true;
					// timeline[i].color = proposal.step === 5 ? 'limegreen' : '#007bff';
					break;
				}
			}

			let history;
			if(proposal.history && Array.isArray(proposal.history)) {
				history = proposal.history;
			} else {
				history = [];
			}

			// console.log(history);
			// console.log(timeline);
			// console.log(index);

			for(let item of history) {
				item.color = 'lime';
			}

			let fullTimeline = history.concat(timeline.splice(index));

			for(let item1 of fullTimeline) {
				for(let item2 of ProposalService.proposalSteps) {
					if(item1.step === item2.step) {
						item1.stepName = item2.stepName;
						break;
					}
				}
			}

			fullTimeline.unshift({head: true, stepName: ''});

			// console.log(fullTimeline);

			return fullTimeline;
		});
	}

	ensureNotNull(value) {
		return !value ? ' ' : value;
	}

	showTimeFormat(value) {
		return !value ? ' ' : moment(new Date(value)).format("YYYY-MM-DD HH:mm");
	}

	createPdf(data) {
		let basicInfo = [
			[{ text: '实验名称', colSpan: 2 }, '', this.ensureNotNull(data.experimentName)],
			[{ text: '\n\n\n实验负责人信息', rowSpan: 6 }, '姓名', this.ensureNotNull(data.ownerName)],
			['', '单位', this.ensureNotNull(data.ownerOrganization)],
			['', '职称', this.ensureNotNull(data.ownerTitle)],
			['', '电话', this.ensureNotNull(data.ownerPhone)],
			['', '邮箱', this.ensureNotNull(data.ownerEmail)],
			['', '通讯地址', this.ensureNotNull(data.ownerAddress)],
		];

		if(data.participants && data.participants.length) {
			basicInfo.push(
				['实验参与人员', '电话', '单位'],
			);
			for(let participant of data.participants) {
				basicInfo.push(
					[this.ensureNotNull(participant.name), this.ensureNotNull(participant.organization), this.ensureNotNull(participant.phone)],
				);
			}
		}

		basicInfo.push(
			// [{ text: '申请类型（选项：常规测试、首次申请、免费机时等）', colSpan: 2 }, '', this.ensureNotNull(data.applicationType)],
			[{ text: '申请类型（选项：常规测试、首次申请等）', colSpan: 2 }, '', this.ensureNotNull(data.applicationType)],
			[{ text: '项目来源和性质（选项：科研、企业、自由等）', colSpan: 2 }, '', this.ensureNotNull(data.projectProperty)],
			[{ text: '预期开展实验的日期', colSpan: 2 }, '', this.showTimeFormat(data.expectedDate)],
		);


		let docDefinition = {
			defaultStyle: {
				font: 'fangzhen',
			},

			content: [
				{ alignment: 'right', text: `束流申请编号：${data.number}`, fontSize: 12, bold: false, margin: [0, 0, 0, 8] },
				{ alignment: 'center', text: '伴生质子束线束流申请表', fontSize: 18, bold: true, margin: [0, 0, 0, 8] },
				{ text: '1. 基本信息', fontSize: 14, bold: true, margin: [0, 0, 0, 8] },
				{
					table: {
						widths: ['25%', '25%', '50%'],
						// headerRows: 9,
						body: basicInfo
					}
				},

				{ text: '2. 样品及质子束流需求', fontSize: 14, bold: true, margin: [0, 30, 0, 8] },
				{
					table: {
						widths: ['50%', '50%'],
						// headerRows: 5,
						body: [
							['样品类型及名称', this.ensureNotNull(data.sampleType)],
							['质子能量范围', this.ensureNotNull(data.protonEnergyRange)],
							['束流流强（flux）或辐照剂量要求', this.ensureNotNull(data.protonBeamIntensity)],
							['质子束斑大小', this.ensureNotNull(data.protonBeamSpotSize)],
							['申请束流时间（包含实验准备时间）', this.ensureNotNull(data.requestBeamTime)],
							['其他设备需求', this.ensureNotNull(data.otherDeviceRequirement)],
						]
					}
				},

				{ text: '3. 样品安全审查项目', fontSize: 14, bold: true, margin: [0, 30, 0, 8] },
				{
					table: {
						widths: ['50%', '50%'],
						body: [
							[{ text: '样品形态', rowSpan: 2 }, this.ensureNotNull(data.sampleState ? data.sampleState.toString() : data.sampleState)],
							['', this.ensureNotNull('')],
							['样品体积', this.ensureNotNull(data.sampleVolume)],
							[{ text: '样品重量', rowSpan: 2 }, this.ensureNotNull(data.sampleWeight ? data.sampleWeight.toString() : data.sampleWeight)],
							['', this.ensureNotNull(data.sampleWeightDetail)],
							[{ text: '安全性申报', rowSpan: 2 }, this.ensureNotNull(data.sampleSecurityDeclaration ? data.sampleSecurityDeclaration.toString() : data.sampleSecurityDeclaration)],
							['', this.ensureNotNull(data.sampleSecurityRadiationDetail)],
							['样品环境特殊要求', this.ensureNotNull(data.sampleEnvironmentSpecialRequirement)],
						]
					}
				},

				{ text: '4. 研究背景和意义', fontSize: 14, bold: true, pageBreak: 'before', margin: [0, 0, 0, 8] },
				{
					table: {
						widths: ['100%'],
						heights: [160],
						headerRows: 1,
						body: [
							[this.ensureNotNull(data.researchBackground)],
						]
					}
				},

				{ text: '5. 研究内容和预期成果', fontSize: 14, bold: true, margin: [0, 30, 0, 8] },
				{
					table: {
						widths: ['100%'],
						heights: [160],
						headerRows: 1,
						body: [
							[this.ensureNotNull(data.researchContent)],
						]
					}
				},

				{ text: '6. 其他实验条件及其他说明', fontSize: 14, bold: true, margin: [0, 30, 0, 8] },
				{
					table: {
						widths: ['100%'],
						heights: [160],
						headerRows: 1,
						body: [
							[this.ensureNotNull(data.otherComment)],
						]
					}
				},
			]
		};

		pdfMake.createPdf(docDefinition).open();
	}

	createExperimentSummary(proposal) {
		let data = proposal.summary;
		let dateStr = moment(data.date).format("YYYY年M月D日");

		let basicInfo = [
			[{ text: '实验名称', colSpan: 2, alignment: 'center' }, '', { text: this.ensureNotNull(data.experimentName), colSpan: 1, alignment: 'center' }],
			[{ text: '实验负责人信息', rowSpan: 3, alignment: 'center' }, { text: '姓名', alignment: 'center' }, { text: this.ensureNotNull(data.ownerName), alignment: 'center' }],
			['', { text: '单位', alignment: 'center' }, { text: this.ensureNotNull(data.ownerOrganization), alignment: 'center' }],
			['', { text: '电话', alignment: 'center' }, { text: this.ensureNotNull(data.ownerPhone), alignment: 'center' }],
		];

		// basicInfo.push(
		// 	[{ text: '实验参与人员', colSpan: 2, rowSpan: 3 }, '', `111        222`],
		// 	[{ text: '', colSpan: 2}, '', `333        444`],
		// 	[{ text: '', colSpan: 2}, '', `555        666`],
		// );

		if(data.participants && data.participants.length) {
			for(let i=0; i<data.participants.length; i++) {
				if(i===0) {
					basicInfo.push(
						[{ text: '实验参与人员', colSpan: 2, rowSpan: data.participants.length, alignment: 'center' }, '', { text: `${data.participants[i].name}        ${data.participants[i].phone}`, alignment: 'center' }],
					);
				} else {
					basicInfo.push(
						[{ text: '', colSpan: 2 }, '', { text: `${data.participants[i].name}        ${data.participants[i].phone}`, alignment: 'center' }],
					);
				}
			}
		}

		basicInfo.push(
			[{ text: '项目来源和性质', colSpan: 2, alignment: 'center' }, '', { text: this.ensureNotNull(data.projectProperty), colSpan: 1, alignment: 'center' }],
			[{ text: '实验开始时间', colSpan: 2, alignment: 'center' }, '', { text: this.showTimeFormat(data.startDate), colSpan: 1, alignment: 'center' }],
			[{ text: '实验结束时间', colSpan: 2, alignment: 'center' }, '', { text: this.showTimeFormat(data.endDate), colSpan: 1, alignment: 'center' }],
			[{ text: '分配机时（小时）', colSpan: 2, alignment: 'center' }, '', { text: this.ensureNotNull(data.beamTime), colSpan: 1, alignment: 'center' }],
			[{ text: '样品类型及名称', colSpan: 2, alignment: 'center' }, '', { text: this.ensureNotNull(data.sampleType), colSpan: 1, alignment: 'center' }],
			[{ text: '质子能量范围', colSpan: 2, alignment: 'center' }, '', { text: this.ensureNotNull(data.protonEnergyRange), colSpan: 1, alignment: 'center' }],
			[{ text: '质子束班大小', colSpan: 2, alignment: 'center' }, '', { text: this.ensureNotNull(data.protonBeamSpotSize), colSpan: 1, alignment: 'center' }],
			[{ text: '实验内容', colSpan: 2, alignment: 'center' }, '', { text: this.ensureNotNull(data.experimentContent), colSpan: 1, alignment: 'left' }],
		);

		let heights = [];
		console.log(basicInfo.length);
		for(let i=0; i<basicInfo.length; i++) {
			if(i===basicInfo.length-1) {
				heights.push(150);
			} else {
				heights.push(15);
			}
		}

		let docDefinition = {
			defaultStyle: {
				font: 'fangzhen',
			},

			content: [
				// {columns: [
				// 	{
				// 		text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Malit profecta versatur nomine ocurreret multavit, officiis viveremus aeternum superstitio suspicor alia nostram, quando nostros congressus susceperant concederetur leguntur iam, vigiliae democritea tantopere causae, atilii plerumque ipsas potitur pertineant multis rem quaeri pro, legendum didicisse credere ex maluisset per videtis. Cur discordans praetereat aliae ruinae dirigentur orestem eodem, praetermittenda divinum. Collegisti, deteriora malint loquuntur officii cotidie finitas referri doleamus ambigua acute. Adhaesiones ratione beate arbitraretur detractis perdiscere, constituant hostis polyaeno. Diu concederetur.'
				// 	},
				// 	{
				// 		text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Malit profecta versatur nomine ocurreret multavit, officiis viveremus aeternum superstitio suspicor alia nostram, quando nostros congressus susceperant concederetur leguntur iam, vigiliae democritea tantopere causae, atilii plerumque ipsas potitur pertineant multis rem quaeri pro, legendum didicisse credere ex maluisset per videtis. Cur discordans praetereat aliae ruinae dirigentur orestem eodem, praetermittenda divinum. Collegisti, deteriora malint loquuntur officii cotidie finitas referri doleamus ambigua acute. Adhaesiones ratione beate arbitraretur detractis perdiscere, constituant hostis polyaeno. Diu concederetur.'
				// 	}
				// ]},
				{ alignment: 'center', text: '伴生质子束线用户实验记录表', fontSize: 18, bold: true, margin: [0, 0, 0, 20] },
				// { alignment: 'left', text: `实验编号：${data.number}    日期：${dateStr}`, fontSize: 12, bold: false, margin: [0, 0, 0, 8] },
				{
					columns: [
						{
							text: `实验编号：${data.number}`
						},
						{
							text: ``
						},
						{
							text: `日期：${dateStr}`
						}
					],
					margin: [0, 0, 0, 8]
				},
				{
					table: {
						// heights: [15, 15, 15, 45], 
						heights: heights, 
						widths: ['25%', '10%', '*'],
						// headerRows: 4,
						body: basicInfo
					},
				},
				{ alignment: 'right', text: `实验人员签字：                    日期：`, fontSize: 12, bold: false, margin: [0, 20, 100, 0] },
			]
		};

		pdfMake.createPdf(docDefinition).open();
	}

	canAutoSave(proposal) {
		let canAutoSave;
		canAutoSave = (proposal.experimentName && proposal.experimentName.length);
		return canAutoSave;
	}

	canEditProposal(proposal) {
		return proposal.step === 0;
	}

	canDeleteProposal(proposal) {
		return proposal.step === 0;
	}

	canSummarizeProposal(proposal) {
		return proposal.step === 3;
	}

	canGenerateApplicationForm(proposal) {
		return proposal.step > 0;
	}

	canGenerateExperimentRecord(proposal) {
		return proposal.step === 4;
	}

	validateProposalSubmission(proposal) {
		let validity = { valid: true, message: null };

		if(!proposal.experimentName) {
			validity = { valid: false, message: '实验名称不能为空' };
			return validity;
		}
		if(!proposal.applicationType) {
			validity = { valid: false, message: '申请类型不能为空' };
			return validity;
		}
		if(!proposal.projectProperty) {
			validity = { valid: false, message: '项目来源和性质不能为空' };
			return validity;
		}
		if(!proposal.expectedDate) {
			validity = { valid: false, message: '预期开展实验日期不能为空' };
			return validity;
		}
		if(!proposal.ownerName) {
			validity = { valid: false, message: '负责人姓名不能为空' };
			return validity;
		}
		if(!proposal.ownerOrganization) {
			validity = { valid: false, message: '负责人单位不能为空' };
			return validity;
		}
		if(!proposal.ownerTitle) {
			validity = { valid: false, message: '负责人职称不能为空' };
			return validity;
		}
		if(!proposal.ownerPhone) {
			validity = { valid: false, message: '负责人电话不能为空' };
			return validity;
		}
		if(!proposal.ownerEmail) {
			validity = { valid: false, message: '负责人邮箱不能为空' };
			return validity;
		}
		if(!proposal.ownerAddress) {
			validity = { valid: false, message: '负责人通讯地址不能为空' };
			return validity;
		}
		if(!proposal.sampleType) {
			validity = { valid: false, message: '样品类型及名称不能为空' };
			return validity;
		}
		if(!proposal.protonEnergyRange) {
			validity = { valid: false, message: '质子能量范围不能为空' };
			return validity;
		}
		if(!proposal.protonBeamIntensity) {
			validity = { valid: false, message: '束流流强（flux）或辐照剂量要求不能为空' };
			return validity;
		}
		// if(!proposal.protonBeamSpotSize) {
		// 	validity = { valid: false, message: '质子束斑大小不能为空' };
		// 	return validity;
		// }
		if(typeof(proposal.requestBeamTime) != 'number' && !proposal.requestBeamTime) {
			validity = { valid: false, message: '申请束流时间不能为空' };
			return validity;
		}

		if(!proposal.sampleState || !proposal.sampleState.length) {
			validity = { valid: false, message: '样品形态不能为空' };
			return validity;
		}
		if(!proposal.sampleVolume) {
			validity = { valid: false, message: '样品体积不能为空' };
			return validity;
		}
		if(!proposal.sampleWeight) {
			validity = { valid: false, message: '样品重量不能为空' };
			return validity;
		}
		if(!proposal.sampleSecurityDeclaration || !proposal.sampleSecurityDeclaration.length) {
			validity = { valid: false, message: '安全性申报不能为空' };
			return validity;
		}
		if(!proposal.sampleEnvironmentSpecialRequirement) {
			validity = { valid: false, message: '样品环境特殊要求不能为空' };
			return validity;
		}

		if(!proposal.otherComment) {
			validity = { valid: false, message: '补充说明不能为空' };
			return validity;
		}

		return validity;
	}

	validateProposalSummary(summary) {
		let validity = { valid: true, message: null };

		if(!summary.experimentName) {
			validity = { valid: false, message: '实验名称不能为空' };
			return validity;
		}
		if(!summary.applicationType) {
			validity = { valid: false, message: '申请类型不能为空' };
			return validity;
		}
		if(!summary.projectProperty) {
			validity = { valid: false, message: '项目来源和性质不能为空' };
			return validity;
		}
		if(!summary.startDate) {
			validity = { valid: false, message: '实验开始时间不能为空' };
			return validity;
		}
		if(!summary.endDate) {
			validity = { valid: false, message: '实验结束时间不能为空' };
			return validity;
		}
		if(!summary.ownerName) {
			validity = { valid: false, message: '负责人姓名不能为空' };
			return validity;
		}
		if(!summary.ownerOrganization) {
			validity = { valid: false, message: '负责人单位不能为空' };
			return validity;
		}
		if(!summary.ownerPhone) {
			validity = { valid: false, message: '负责人电话不能为空' };
			return validity;
		}
		if(!summary.sampleType) {
			validity = { valid: false, message: '样品类型及名称不能为空' };
			return validity;
		}
		if(!summary.protonEnergyRange) {
			validity = { valid: false, message: '质子能量范围不能为空' };
			return validity;
		}
		if(!summary.protonBeamSpotSize) {
			validity = { valid: false, message: '质子束斑大小不能为空' };
			return validity;
		}

		return validity;
	}
	
}